/* eslint-disable no-empty-function,react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { CustomSelect } from "../../../../../components/ui/CustomSelect/CustomSelect";
import { protocols, PROXY_TYPES } from "../../../../../utils/constants";
import { ModalInput } from "../../../../../components/ui/ModalInput/ModalInput";
import { useCurrentRentPeriod, useTranslation } from "../../../../../hooks";
import { ModalSelect } from "../../../../../components/ui/ModalSelect/ModalSelect";
import { classNames } from "../../../../../utils/helpers/classNames";
import { getInitialQuantity } from "../../../../../utils/helpers/getInitialQuantity";
import { MobileoperatorParams } from "./MobileoperatorParams";
import { Countries } from "./Countries";

export const Settings = ({ methods, selectedStep, setSelectedStep }) => {
  const { lang } = useParams();
  const settingsRef = useRef(null);

  const [mobileOperators, setMobileOperators] = useState([]);

  const { proxies } = useSelector((state) => state.content);
  const {
    formPlaceholders,
    cabinet: { newOrder: { settings, proxy, minQuantityMessage } }
  } = useTranslation();

  const { proxyType, mobileOperator } = methods.watch();

  const rentPeriods = useCurrentRentPeriod(proxyType?.value);

  const getProxyOptions = () => proxies?.enabled
    ?.map(({ code, label }) => ({ value: code, label: `${label} ${proxy}` })) || [];

  useEffect(() => {
    const handleFocusIn = (e) => {
      if (settingsRef.current && settingsRef.current.contains(e.target) && e.target !== settingsRef.current) {
        setSelectedStep("settings");
      }
    };

    document.addEventListener("focusin", handleFocusIn);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, []);

  useEffect(() => {
    if (!proxyType) return;

    const { value } = proxyType;
    const label = `${PROXY_TYPES[value.toLowerCase()].label} ${proxy}`;

    methods.setValue("proxyType", { value, label });
  }, [lang]);

  const resetFormState = () => {
    methods.reset(methods.getValues());
  };

  const changeProxyHandler = () => {
    methods.setValue("country", null);
    methods.setValue("rent", null);
    methods.setValue("mobileOperator", null);
    methods.setValue("modemRotationMin", null);

    resetFormState();
  };

  return (
    <div className="new-order__settings" ref={settingsRef}>
      <div className={classNames("new-order__step", { "new-order__step--active": selectedStep === "settings" })}>
        <div className="new-order__step-number"><span>1</span></div>
        <div className="new-order__title">{settings}</div>
      </div>
      <CustomSelect
        testId="proxy-type"
        name="proxyType"
        rules={{ required: true }}
        value={proxyType}
        options={getProxyOptions()}
        changeFunc={changeProxyHandler}
      />
      <Countries
        testId="countries"
        proxyCode={proxyType?.value}
        setCountryParams={() => {
        }}
        setMobileOperators={setMobileOperators}
      />
      <MobileoperatorParams
        proxyCode={proxyType?.value}
        mobileOperator={mobileOperator}
        mobileOperators={mobileOperators}
        setMobileOperator={() => {
        }}
        setModemRotationMin={() => {
        }}
      />
      {proxyType?.value === PROXY_TYPES.ipv6.code && (
        <ModalSelect
          testId="ipv6-protocol"
          name="proxyProtocol"
          rules={{ required: true }}
          options={protocols}
          placeholder={formPlaceholders?.protocol}
          onChange={() => {}}
        />
      )}
      <ModalInput
        testId="quantity"
        type="text"
        name="quantity"
        proxyType={proxyType?.value}
        placeholder={formPlaceholders?.quantity2}
        placeholderNoData={formPlaceholders?.quantity1}
        handler={() => {}}
        quantity
        rules={{
          required: true,
          min: {
            value: proxyType?.value === "IPv6" ? 10 : 1,
            message: `${minQuantityMessage} ${getInitialQuantity(proxyType?.value)} IPs`
          }
        }}
        fieldErrors={methods?.formState?.errors?.quantity}
      />
      <ModalSelect
        testId="rent-period"
        name="rent"
        rules={{ required: true }}
        options={rentPeriods}
        placeholder={formPlaceholders?.rentPeriod}
        onChange={() => {}}
      />
    </div>
  );
};
